module.exports = __webpack_public_path__ + "static/media/location-icon.40bcef8f.png";